import { render } from "./AddressBook.vue?vue&type=template&id=b879be94&ts=true"
import script from "./AddressBook.vue?vue&type=script&lang=ts"
export * from "./AddressBook.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__